export default __webpack_public_path__ + "static/media/opensans-italic-webfont.717e8c37.woff";